<template>
  <div class="question_tb">
    <el-table
      :data="list"
      style="width: 100%"
      :header-cell-style="{
        background: '#F0F0F0',
        fontSize: '14px',
        height: '50px',
        fontWeight: 500,
        color: '#333',
      }"
      :cell-style="cellStyleFn"
    >
      <el-table-column prop="id" label="问卷ID" width="100"> </el-table-column>
      <el-table-column prop="title" label="问卷名称"> </el-table-column>
      <el-table-column width="80" label="是否考核">
        <template slot-scope="{ row }">
          <div>{{ row.is_check == 1 ? "是" : "否" }}</div>
        </template>
      </el-table-column>
      <el-table-column width="200" label="任务起止时间">
        <template slot-scope="{ row }">
          <div v-if="!row.start_date && !row.end_date">——</div>
          <div v-else>
            <span>{{ row.start_date }}</span> ~
            <span>{{ row.end_date }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="questionnaire_type" label="类型">
        <!-- <template slot-scope="{ row }">
          <div>{{ row.join_type | filterType }}</div>
        </template> -->
      </el-table-column>
      <el-table-column prop="address" width="180" label="提交时间">
        <template slot-scope="{ row }">
          <div>
            <!-- <span>{{ row.start_date }}</span
            >~
            <span>{{ row.end_date }}</span> -->
            <span v-if="row.submit_time">{{
              row.submit_time | filterTime
            }}</span>
            <span v-else>未提交</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="100" label="状态">
          <template slot-scope="{row}">
              <p>{{row.have_complete?'已完成':'未完成'}}</p>
          </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="{ row }">
          <div>
            <span v-if="taskState(row.start_date, row.end_date) == 1">-</span>
            <template v-if="taskState(row.start_date, row.end_date) == 2">
              <span
                class="c-main pointer"
                @click="operationQuestion(row)"
              >
                {{ row.submit_type == null || row.submit_type == 1 ? "答卷" : "" }}
                {{ row.submit_type == 2 && row.is_allow_answer ? "修改" : "" }}
                {{ row.submit_type == 2 && !row.is_allow_answer ? "查看" : "" }}
              </span>
            </template>
            <template v-if="taskState(row.start_date, row.end_date) == 3">
              <span
                class="c-main pointer"
                @click="operationQuestion(row)"
                v-if="row.submit_type == 2"
              >
                查看
              </span>
              <span v-else>-</span>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  //   filters: {
  //     filterType(type) {
  //       // 问卷类型：1投票 2评价 3研修日志 4普通
  //       return type == 1
  //         ? "投票"
  //         : type == 2
  //         ? "评价"
  //         : type == 3
  //         ? "研修日志"
  //         : "普通问卷";
  //     },
  //   },
  methods: {
    // 问卷答题/查看
    operationQuestion(e) {
      // is_complete 0未完成，2已完成
      if (e.is_complete == 2) {
      } else {
        let query = {
          questionId: e.id
        }
        if (e.is_allow_answer) {
          query.is_allow_answer = true
        }
        this.$router.push({
          path: "/AnswerSheet",
          query,
        });
      }
    },
    // 修改某一列单元样式
    cellStyleFn({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1 || columnIndex == 4) {
        return `color:#3489FF;`;
      }
    },
    //任务状态
    taskState(start_date, end_date) {

      //状态值
      let state = 0;

      // 获取当前时间的时间戳
      const currentTimeStamp = new Date().getTime();

      // 获取开始的时间戳
      const startTimeStamp = new Date(start_date).getTime();

      // 获取结束的时间戳
      const endTimeStamp = new Date(end_date).getTime();

      // 比较时间戳
      if (currentTimeStamp < startTimeStamp) {
        state = 1;
      }
      if (currentTimeStamp >= startTimeStamp && currentTimeStamp <= endTimeStamp) {
        state = 2;
      }
      if (currentTimeStamp > endTimeStamp) {
        state = 3;
      }

      return state;

    }
  },
};
</script>
 
<style lang = "less" scoped>
.question_tb {
  padding: 24px 0 30px;
  /deep/ .el-table {
    td {
      text-align: center;
    }
    th {
      text-align: center;
    }
  }
}
</style>